import React, { useEffect, useState } from "react";
import {
  FaPhone,
  FaWhatsapp,
  FaTimes,
  FaMapMarkerAlt,
} from "react-icons/fa";

const formatPhoneNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  if (digits.length === 10) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }

  return number;
};

const formatWhatsAppNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  // Convert South African number from 0XXXXXXXXX
  // to international format 27XXXXXXXXX
  if (digits.startsWith("0") && digits.length === 10) {
    return `27${digits.slice(1)}`;
  }

  return digits;
};

const WantProductDetailsModal = ({ product, onClose }) => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (product) {
      setIsActive(
        product.is_active !== undefined
          ? product.is_active
          : true
      );
    }
  }, [product]);

  if (!product) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">

      {/* MODAL */}
      <div className="relative bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl shadow-2xl">

        {/* CLOSE BUTTON */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-20 bg-red-600 hover:bg-red-700 text-white rounded-full w-9 h-9 flex items-center justify-center transition"
          aria-label="Close"
        >
          <FaTimes />
        </button>

        {/* HEADER */}
        <div className="px-6 py-5 bg-gray-50 border-b border-gray-200 pr-16">

          <div className="flex items-start justify-between gap-4">

            {/* NAME */}
            <h2 className="text-2xl font-bold text-gray-900">
              {product.name}
            </h2>

            {/* STATUS */}
            <span
              className={`flex-shrink-0 px-3 py-1 rounded-full text-xs font-bold tracking-wide ${
                isActive
                  ? "bg-blue-700 text-white"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              {isActive ? "WANTED" : "FULFILLED"}
            </span>

          </div>

        </div>

        {/* DETAILS */}
        <div className="p-6">

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            {/* MAIN CONTENT */}
            <div className="md:col-span-2">

              {/* DESCRIPTION */}
              {product.description && (
                <div className="mb-6">

                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Description
                  </h3>

                  <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                    {product.description}
                  </p>

                </div>
              )}

            </div>

            {/* SIDEBAR DETAILS */}
            <div className="flex flex-col gap-5">

              {/* BUDGET */}
              {product.budget && (
                <div>

                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    Budget
                  </h3>

                  <p className="text-green-800 font-bold text-xl">
                    R{Number(product.budget).toLocaleString("en-ZA", {
                      maximumFractionDigits: 0,
                    })}
                  </p>

                </div>
              )}

              {/* LOCATION */}
              {product.location && (
                <div>

                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Location
                  </h3>

                  <div className="flex items-center gap-2 text-gray-700">

                    <FaMapMarkerAlt className="text-green-700 flex-shrink-0" />

                    <span>
                      {product.location}
                    </span>

                  </div>

                </div>
              )}

            </div>

          </div>

          {/* CONTACT DETAILS */}
          {(product.contact_phone || product.contact_whatsapp) && (
            <div className="border-t border-gray-200 pt-5 mt-2">

              <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                Contact
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                {/* PHONE */}
                {product.contact_phone && (
                  <a
                    href={`tel:${product.contact_phone}`}
                    onClick={(e) => e.stopPropagation()}
                    className="flex items-center gap-3 text-gray-700 hover:text-green-800 transition"
                  >
                    <FaPhone className="text-green-800 flex-shrink-0" />

                    <span>
                      {formatPhoneNumber(product.contact_phone)}
                    </span>
                  </a>
                )}

                {/* WHATSAPP */}
                {product.contact_whatsapp && (
                  <a
                    href={`https://wa.me/${formatWhatsAppNumber(
                      product.contact_whatsapp
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="flex items-center gap-3 text-gray-700 hover:text-green-800 transition"
                  >
                    <FaWhatsapp className="text-green-700 flex-shrink-0" />

                    <span>
                      {formatPhoneNumber(product.contact_whatsapp)}
                    </span>
                  </a>
                )}

              </div>

            </div>
          )}

        </div>

      </div>

    </div>
  );
};

export default WantProductDetailsModal;